import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MarketingSection } from '../components/MarketingSection';
export const MarketingPage = () => {
  return <div className="min-h-screen bg-[#f2f2ed]" data-id="element-1036">
      <Header data-id="element-1037" />
      <main className="pt-20" data-id="element-1038">
        <MarketingSection data-id="element-1039" />
      </main>
      <Footer data-id="element-1040" />
    </div>;
};